import { render } from "./MenuCategoryBlock.vue?vue&type=template&id=f4153336&scoped=true"
import script from "./MenuCategoryBlock.vue?vue&type=script&lang=js"
export * from "./MenuCategoryBlock.vue?vue&type=script&lang=js"

import "./MenuCategoryBlock.vue?vue&type=style&index=0&id=f4153336&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4153336"]])

export default __exports__